export default __webpack_public_path__ + "static/7 Habits of Healthy Sleepers-200f77c6d3048fe5a2976a85045da128.jpg";